<script>
export default {
  name: "navDashboardAdmin",
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    nameApp: process.env.VUE_APP_NAME,
  }),
};
</script>
<template>
  <div class="nav d-flex flex-row">
    <div class="logo">
      <img src="/img/logo.png" alt="" class="img-fluid" style="width: 170px" />
    </div>
    <div class="nameView lg">
      <div class="d-flex flex-column">
        <strong
          style="font-weight: 500; text-transform: uppercase; font-size: 15px"
          >Missing Calls {{ nameApp }} -
          <small style="text-transform: lowercase">v</small
          >{{ version }}</strong
        >
        <small style="font-size: 12px"
          >Panel de administración</small
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.nav {
  z-index: 1000;
  align-items: center;
  padding-left: 24px;
  position: fixed;
  background: white;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  height: 60px;
  box-shadow: 0px 3px 4px 5p;
  box-shadow: 0px 4px 30px 3px #0000000d;
  .nameView {
    margin-left: 81px;
    font-size: 14px;
    font-weight: 500;
    color: #767676;
  }
}
</style>
